import React from "react";
import PropTypes from "prop-types";
import * as Styled from "../styles";
import IconSelect from "./IconSelect";

const AccordionRightDropDown = React.memo(function AccordionRightDropDown({
  title,
  selectedItemId,
  handleItemSelect,
  items,
}) {
  return (
    <Styled.TitleContainer>
      <Styled.TitleFieldText>{title}</Styled.TitleFieldText>
      <IconSelect
        items={items}
        selectedItemId={selectedItemId}
        onItemSelect={handleItemSelect}
      />
    </Styled.TitleContainer>
  );
});

AccordionRightDropDown.propTypes = {
  title: PropTypes.string,
  selectedItemId: PropTypes.number.isRequired,
  handleItemSelect: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      icons: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          component: PropTypes.element.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

AccordionRightDropDown.defaultProps = {
  title: "Title Text",
};

export default AccordionRightDropDown;
